import { render } from "./SeverityChange.vue?vue&type=template&id=287be2c2&scoped=true"
import script from "./SeverityChange.vue?vue&type=script&lang=js"
export * from "./SeverityChange.vue?vue&type=script&lang=js"

import "./SeverityChange.vue?vue&type=style&index=0&id=287be2c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287be2c2"]])

export default __exports__